/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';

import './index.scss';

Modal.setAppElement('#root');

class InsuranceDuplicate extends React.Component {
  render() {
    const {
      modelopen,
      closeServiceModal,
    } = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Duplicate Found</div>
              <button className="modal-close" onClick={closeServiceModal}>
                <i className="material-icons">close</i>
              </button>
              <div className="sub-title">
                The insurance you’d like to add already exists in the list
              </div>
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={closeServiceModal}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InsuranceDuplicate;
